<template>

    <div>
        <v-btn
                round
                color="#FCE15C"
                dark
                v-on:click="sheet = !sheet"
        >
            <v-icon>
                info
            </v-icon>
        </v-btn>
        <v-bottom-sheet v-model="sheet" color="blue">
            <v-list>
                <div v-for="i in 6">
                    <v-list-tile>
                        <v-layout>
                            <v-icon :key="i" :color="colors[i-1]">
                                stars
                            </v-icon>
                            <div>{{categories[i-1]}}</div>
                        </v-layout>
                    </v-list-tile>
                </div>
            </v-list>
        </v-bottom-sheet>
    </div>
</template>

<script>

    export default {
        data: () => ({
            colors: ['#B78DE4', '#FCE15C', '#FF7BA3', '#2dde98', '#F5DABD', "#ffc2e5"],
            sheet: false,
            categories: ['Cues i Xifres', 'Documents', 'Empadronament', 'Estrangeria', 'Cens electoral', 'Territori'],
        })
    }

</script>

<style scoped>

</style>
